import { Link } from "@tanstack/react-router";
import { analyticsAvailable, setRecordingChoice, useRecordingChoice } from "../lib/analytics";

/**
 * Decision D46: asks once per browser before PostHog records anything. Both answers are one
 * click, and Your account can change it later.
 */
export function RecordingNotice() {
  const choice = useRecordingChoice();
  if (!analyticsAvailable || choice !== null) return null;
  return (
    <aside
      role="dialog"
      aria-labelledby="recording-title"
      className="fixed right-4 bottom-4 left-4 z-30 flex flex-col gap-3 rounded-tile border border-line bg-bg p-5 shadow-tip sm:left-auto sm:w-[380px]"
    >
      <h2 id="recording-title" className="text-[15px] leading-[18px] font-extrabold">
        Can we record how you use Backplan?
      </h2>
      <p className="text-[13px] leading-[1.5] text-muted">
        During the pilot we'd like to replay sessions to see where Backplan gets in your way. Recordings hide every piece of text and everything you type. You can change this
        on{" "}
        <Link to="/account" className="font-bold text-brand-dark hover:underline">
          Your account
        </Link>
        .
      </p>
      <div className="flex justify-end gap-2.5">
        <button type="button" className="btn-secondary btn-md py-2.5 text-sm" onClick={() => setRecordingChoice("no")}>
          No thanks
        </button>
        <button type="button" className="btn-primary btn-md py-2.5 text-sm" onClick={() => setRecordingChoice("yes")}>
          That's fine
        </button>
      </div>
    </aside>
  );
}
